export default __webpack_public_path__ + "a6534d6fe221dceb8093458f2f4b7226.png";